module.exports = __webpack_public_path__ + "sy.41e5cf69000767c09bcd.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/sy.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/sy.svg
// module chunks = styles